export const KNOWN_ERRORS = {
	INSUFFICIENT_BALANCE: "Not enough tokens",
	ZERO_AMOUNT: "Amount cannot be zero",
};
